module.exports = __webpack_public_path__ + "img/symbol-hash-center.d1893896.png";